<template>
  <div class="timeline-basic">
    <slot />
  </div>
</template>
<script setup lang="ts"></script>
